import { Typography } from 'antd';
import { LegalPage } from './LegalPage';

const { Title, Paragraph } = Typography;

export function PrivacyPage() {
  return (
    <LegalPage title="Privacy Policy" updated="July 15, 2026">
      <Paragraph>
        This Privacy Policy explains how the Content Agents platform (&quot;we&quot;,
        &quot;us&quot;) collects, uses and protects information when you use our services (the
        &quot;Service&quot;).
      </Paragraph>

      <Title level={4}>1. Information we collect</Title>
      <ul>
        <li>
          <b>Account information</b> — such as your name, email address and organization details.
        </li>
        <li>
          <b>Content you create</b> — the topics, scripts, images, videos and captions you generate
          or upload.
        </li>
        <li>
          <b>Connected-platform data</b> — when you connect a third-party account (YouTube, TikTok,
          Facebook, Instagram), we store the access tokens and the account/page/channel identifiers
          needed to publish on your behalf. Tokens are encrypted at rest.
        </li>
        <li>
          <b>Usage data</b> — basic logs needed to operate, secure and troubleshoot the Service.
        </li>
      </ul>

      <Title level={4}>2. How we use information</Title>
      <Paragraph>
        We use information to provide and improve the Service: generating and scheduling content,
        publishing to the platforms you connect, applying branding you request, and maintaining
        security. We do not sell your personal information.
      </Paragraph>

      <Title level={4}>3. Connected platforms</Title>
      <Paragraph>
        We access your connected accounts only to perform the actions you enable (for example,
        uploading and publishing videos, or updating channel/page branding). We request the minimum
        permissions required. You can disconnect any platform at any time from the Integrations
        settings, which revokes our access and removes the stored tokens for that connection.
      </Paragraph>

      <Title level={4}>4. Data sharing</Title>
      <Paragraph>
        We share data only with: (a) the third-party platforms you choose to publish to; and (b)
        infrastructure providers that host the Service, acting on our behalf under confidentiality
        obligations. We may disclose information if required by law.
      </Paragraph>

      <Title level={4}>5. Data retention</Title>
      <Paragraph>
        We retain your content and connection data for as long as your account is active or as
        needed to provide the Service. You can delete content (including generated videos and their
        media) from within the app, and you can request deletion of your account and associated
        data.
      </Paragraph>

      <Title level={4}>6. Your rights</Title>
      <Paragraph>
        Subject to applicable law, you may access, correct, export or delete your personal
        information. To exercise these rights, contact us using the details below.
      </Paragraph>

      <Title level={4}>7. Security</Title>
      <Paragraph>
        We use industry-standard measures to protect your data, including encryption of connection
        tokens at rest. No method of transmission or storage is completely secure, but we work to
        protect your information.
      </Paragraph>

      <Title level={4}>8. Changes</Title>
      <Paragraph>
        We may update this Policy from time to time. We will update the &quot;Last updated&quot;
        date above when we do.
      </Paragraph>

      <Title level={4}>9. Contact &amp; data deletion</Title>
      <Paragraph>
        For privacy questions or to request deletion of your data, contact{' '}
        <a href="mailto:support@clairglow.com">support@clairglow.com</a>.
      </Paragraph>
    </LegalPage>
  );
}
